import { User } from '~services/interfaces'

const useGetProduct = (user: User | null) => {
  const getProduct = (slug: string) => {
    return user && user.data.company.combo.products.find((product) => product.slug === slug)
  }

  return { getProduct }
}

export default useGetProduct
